export default {"src":"/_next/static/media/lock.aab82eb1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};